import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconButtonComponent } from '@core/components/ui-icon-button/icon-button.component';
import type { LinearStepInfo } from '@core/components/linear-step-info/linear-step-info.interfaces';
import { LinearStepInfoComponent } from '@core/components/linear-step-info/linear-step-info.component';
import type { PaymentMethodPersonaType, VoucherConfig } from '@core/services/cash-processor.interface';

@Component({
  selector: 'dcv-voucher-header',
  standalone: true,
  imports: [CommonModule, LinearStepInfoComponent],
  templateUrl: './voucher-header.component.html',
  styleUrl: './voucher-header.component.scss',
})
export class VoucherHeaderComponent implements OnChanges {
  @Input({ required: false }) title: string = '';
  @Input() linearSteps: LinearStepInfo[] = [];
  @Input() clipboard: boolean = true
  @Input() color: string = 'primary';
  @Input() secondaryColor!: string;
  @Input() dividerColor: string = '#C8D5DF';
  @Input() voucherConfiguracion?: VoucherConfig;
  @Input() showReturnBtn?: boolean;
  @Output() clickOnReturnBtn = new EventEmitter();
  metodos!: PaymentMethodPersonaType[];
  metodoSeleccionado!: PaymentMethodPersonaType;

  @Output() cambioMetodo = new EventEmitter<PaymentMethodPersonaType>();

  ngOnChanges(changes: SimpleChanges): void {
    const voucherConfig = this.voucherConfiguracion;
    const version = voucherConfig?.version;
    if (
      changes['voucherConfiguracion']?.currentValue &&
      version === 'V2' &&
      voucherConfig
    ) {
      this.metodos = voucherConfig.payment_method_person_types;
      if (this.metodos) {
        this.metodoSeleccionado = this.metodos.find(
          (t) => t.code === voucherConfig.personTypeSelected,
        )!;
      }

      this.cambioMetodo.emit(this.metodoSeleccionado);
    }
  }

  onSeleccionarMetodo(metodo: PaymentMethodPersonaType) {
    this.metodoSeleccionado = metodo;
    this.cambioMetodo.emit(this.metodoSeleccionado)
  }
}
